export interface ITripRequestLogsStatsArgs {
    filter?: string;
    from?: string;
    to?: string;
}
